import { Modal, Text, Button, Group } from "@mantine/core";
import { useNavigate } from "react-router-dom";

interface ShortlistModalProps {
  opened: boolean;
  onClose: () => void;
  companyName?: string;
  flow?: "shortlist" | "pagination";
}

export default function ShortlistModal({
  opened,
  onClose,
  companyName,
  flow = "shortlist",
}: ShortlistModalProps) {
  const navigate = useNavigate();

  const handleSignUp = () => {
    onClose();
    navigate("/signup");
  };

  const handleLogIn = () => {
    onClose();
    navigate("/login");
  };

  const isPagination = flow === "pagination";
  const title = isPagination ? "Sign up to see more pages" : `Shortlist ${companyName || "Company"}`;
  const body = isPagination
    ? "Create a free account to browse additional pages of verified companies and use the full discovery experience."
    : "Sign up or log in to keep your shortlist in your account and track interesting partners.";

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title}
      centered
      size="md"
      styles={{
        title: {
          fontSize: "20px",
          fontWeight: 600,
        },
      }}
    >
      <Text size="sm" c="slate.6" mb="xl">
        {body}
      </Text>

      <Group justify="flex-end" gap="md">
        <Button variant="outline" color="gray" onClick={onClose}>
          Cancel
        </Button>
        {!isPagination ? (
          <Button variant="outline" onClick={handleLogIn}>
            Log in
          </Button>
        ) : null}
        <Button onClick={handleSignUp}>Sign Up</Button>
      </Group>
    </Modal>
  );
}
